import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';

import {Observable, Subject} from 'rxjs';
import {NgbDropdown, NgbDropdownToggle} from '@ng-bootstrap/ng-bootstrap';
import {ListGroupComponent} from '../list-group/list-group.component';
import {takeUntil} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

export class NavModel {
  id: string;
  text: Observable<string>;

  constructor(id: string, text: Observable<string>) {
    this.id = id;
    this.text = text;
  }
}

@UntilDestroy()
@Component({
  selector: 'ds-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit, AfterViewInit {

  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  @ViewChild(NgbDropdownToggle) dropdownToggle: NgbDropdownToggle;
  @ViewChild(ListGroupComponent) listGroup: ListGroupComponent;
  @Input() navItems: NavModel[];
  @Input() activeNavItem: NavModel;
  /** breakpoint on which elements are hidden under 'show more' dropdown */
  @Input() numberOfShownElements = 5;
  @Input() showMoreText = 'Show More';
  /** breakpoint on which the scrollbar is hidden. Allowed values: '', sm, md, lg, xl */
  @Input() switchToScrollBreakpoint = 'sm';
  @Output() activeIdChange: EventEmitter<string> = new EventEmitter<string>();
  /** Nav items divided in the ons that are part of the dropdown. */
  splitNavItems: NavModel[][];

  ngOnInit() {
    this.splitNavItems = this.splitNavItemsByLimit(this.navItems, this.numberOfShownElements);

  }

  ngAfterViewInit(): void {
    if (this.dropdown) {
      this.dropdown.openChange.pipe(untilDestroyed(this)).subscribe((isOpen) => {
        if (!isOpen) {
          setTimeout(() => {
            this.dropdownToggle.nativeElement.focus();
          });
        }
      });
    }
  }

  /**
   * Splits the navItems into two arrays.
   *
   * @param navItems array with all the navItems.
   * @param numberOfShownElements number to split the array by.
   */
  splitNavItemsByLimit(navItems: NavModel[], numberOfShownElements: number): NavModel[][] {
    const splitNavItems: NavModel[][] = [];
    if (numberOfShownElements && numberOfShownElements > 0) {
      splitNavItems[0] = navItems.slice(0, numberOfShownElements);
      splitNavItems[1] = navItems.slice(numberOfShownElements, navItems.length);
    } else {
      splitNavItems[0] = navItems;
      splitNavItems[1] = [];
    }
    return splitNavItems;
  }

  onNavChange(id: string) {
    this.activeIdChange.emit(id);
    if (this.dropdown) {
      this.dropdown.close();
    }
    if (this.listGroup) {
      this.listGroup.setListItemsToInactive();
    }
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.dropdown) {
      if (!this.dropdown._open) {
        if (event.key === 'Enter') {
          this.dropdown.open();
          this.listGroup.keyboardManager.setFirstItemActive();
        }
      } else {
        if (event.key === 'Escape') {
          this.dropdown.close();
          event.preventDefault();
        } else {
          this.propagateEventToListGroup(event);
        }
      }
    }
  }

  propagateEventToListGroup(event: KeyboardEvent) {
    if (this.listGroup) {
      this.listGroup.handleKeyInput(event);
    }
  }
}
